Customer.Dashboard ||= {}

class Customer.Dashboard.SummaryTicketView extends Backbone.View
  template: JST["backbone/templates/customer/dashboard/summary/main/body/summary_ticket"]

  events:
    "click .select" : "onSelected"
    "dblclick .select" : "disableOnDblClick"
    "dblclick .summary": "onShowTicket"
    "click .summary .see-more-container button" : "onShowTicket"
    "dblclick .summary .see-more-container button" : "disableOnDblClick"
    'click .ticket-attachment-scroll-backwards': 'scrollAttachmentsBackwards'
    'click .ticket-attachment-scroll-forwards': 'scrollAttachmentsForwards'

  initialize: (@options = {}) ->
    @listenTo(@model, 'change', @render)
    lastInteraction = @model.summaryInteraction()
    @template = @findTemplate(lastInteraction) if lastInteraction
    @listenToOnce(Backbone, 'tickets:loaded', @displayAttachmentScroll)

  render: =>
    @trigger('countes:find:spin')
    lastInteraction = @model.summaryInteraction()
    if lastInteraction
      ticket = @model.toJSON()
      @$el.html(@template(conversation: ticket, lastInteraction: lastInteraction, self: @))
    row = @$el.find('.tags-and-groups-row')

    if(@model.isWhatsapp())
      @$el.find('a.sc-picture-preview').on "click", (event) ->
        event.preventDefault()
      @$el.find('a.sc-video-preview').on "click", (event) ->
        event.preventDefault()
      @$el.find('a.sc-location-preview').on "click", (event) ->
        event.preventDefault()
      @$el.find('a.sc-wscontact-see-more').on "click", (event) ->
        event.preventDefault()
      @$el.find('div.document a').on "click", (event) ->
        event.preventDefault()

    if @model.mustShowTagsInSummary()
      cellAttributes = ""
      if @model.mustShowGroupsInSummary()
        cellAttributes += ' class="wider-cell"'
      cellHtml = '<td' + cellAttributes + '><div class="tags summary-tags"></div></td>'

      row.append($(cellHtml))
      @$el.find('.summary-tags').html(@getTagsView().render())

    if lastInteraction.subType() == "gp_review_comment" || lastInteraction.subType() == "apple_app_store_review_comment"
      reviewStarsView = new Monitoring.Views.ReviewStarsView()
      @$el.find('#comment-review-stars').html(reviewStarsView.render().el)
      reviewStarsView.setRating(@_starRating()) if @_starRating()
#    else if lastInteraction.subType() == "apple_app_store_review_comment"
#      reviewStarsView = new Monitoring.Views.ReviewStarsView()
#      @$el.find('#comment-review-stars').html(reviewStarsView.render().el)
#      reviewStarsView.setRating(@_starRating()) if @_starRating()

    if @model.mustShowGroupsInSummary()
      row.append($('<td><div class="summary-groups"></div></td>'))
      @$el.find('.summary-groups').html(@getGroupsView().render())
    @$el.find('.sc-picture-preview').magnificPopup(type:'image', closeOnContentClick: true)
    @trigger('countes:find:stop')
    @

  getTagsView: =>
    @socialContentTagsView ||= new Monitoring.Dashboard.SocialContentTagsView({
      possibleTags: @model.summaryInteraction().possibleTags(),
      selectedTagCodes: @model.summaryInteraction().get('tags')
      suggestedTags: []
      readOnly: true
      withIconAndLabel: true
      groupsInsteadOfTags: false
    })

  getGroupsView: =>
    @groupsView ||= new Monitoring.Dashboard.SocialContentTagsView(
      possibleTags: @model.getGroups()
      selectedTagCodes: @model.getGroups()
      suggestedTags: []
      readOnly: true
      withIconAndLabel: true
      groupsInsteadOfTags: true
    )

  disableOnDblClick: (event) ->
    event.stopPropagation()

  hasTags:(ticket)->
    ticket.dialogue.summary_interaction.tags?.length > 0

  getTranslationFor:(status) ->
    I18n.t('customer.dashboard.conversations.status.' + status.toLowerCase().replace(' ', '_'))

  findTemplate: (lastInteraction) ->
    specificities = [
      [lastInteraction.type(), lastInteraction.subType()],
      [lastInteraction.groupType(), lastInteraction.type()],
      [lastInteraction.groupType()]
    ]

    templates = _.map(specificities, (s) ->
      JST["backbone/templates/customer/ticket/#{s.join('/')}/conversation_summary"]
    )

    ret = _.find(templates, (t) -> t)
    unless ret
      message = "Template for conversation summary does not exist #{JSON.stringify(lastInteraction)}"
      console.warn(message)
      jsLogger.fatal(message)
    ret

  onShowTicket: (event) =>
    return if event && @$el.find('section.summary').tagName is "INPUT"
    if @model.get('loaded')
      @model.open()
    else
      Backbone.trigger 'ui:blocked'
      @$el.find('.open-ticket-button').hide()
      @$el.find('.opening-ticket-button').show()

      @model.fetch({
        silent: true
        global: false
        data: { page: 1 }
        success: (ticket) ->
          try
            ticket.open()
          catch error
            showError('An unexpected error has occurred. Please contact us if this error persists.')
            jsLogger.fatal("The ticket with id: #{ticket.id} could not be opened - #{error?.stack || error}")
        error: (model, response, options) =>
          if (response.status >= 500 )
            showError('An unexpected error has occurred. Please contact us if this error persists.')
            jsLogger.fatal("An error has occurred with the ticket with id: "+ model.id)
          else
            showError('You no longer have access to this ticket.')
      }).complete( =>
        @$el.find('.open-ticket-button').show()
        @$el.find('.opening-ticket-button').hide()
        Backbone.trigger 'ui:unblocked'
      )

  onSelected: (event) =>
    event.stopPropagation()
    @model.select(event.currentTarget.checked)

  destroy: ->
    @model.destroy()
    this.remove()
    return false

  _starRating: ->
    analysisUnit = @model.summaryInteraction()
    data = analysisUnit.get('data')
    if data.sub_type == "gp_review_comment"
      if (data.comment.starRating)  #todo remove that
        data.comment.starRating
      else
        data.userComment.starRating
    else if data.sub_type == "apple_app_store_review_comment"
      if (data.appStoreData.user_id == "Developer")
        data.appStoreData.parent.rating
      else
        data.appStoreData.rating

  scrollAttachmentsBackwards: =>
    if @canScrollAttachmentsBackwards()
      @$el.find(".attachments-section").find(".sc-attachment.d-none").last().removeClass("d-none")
      unless @canScrollAttachmentsBackwards()
        @$el.find(".ticket-attachment-scroll-backwards").find("i").addClass("disabled")
      @$el.find(".ticket-attachment-scroll-forwards").find("i").removeClass("disabled")

  scrollAttachmentsForwards: =>
    if @canScrollAttachmentsForwards()
      @$el.find(".attachments-section").find(".sc-attachment").not(".d-none").first().addClass("d-none")
      unless @canScrollAttachmentsForwards()
        @$el.find(".ticket-attachment-scroll-forwards").find("i").addClass("disabled")
      @$el.find(".ticket-attachment-scroll-backwards").find("i").removeClass("disabled")


  canScrollAttachmentsBackwards: =>
    hiddenPreviousAttachments = @$el.find(".attachments-section").find(".sc-attachment.d-none")
    return hiddenPreviousAttachments.length > 0

  canScrollAttachmentsForwards: =>
    attachmentSectionWidth = @attachmentSectionVisibleWidth()
    singleAttachmentWidth = @$el.find(".attachments-section").find(".sc-attachment").width()
    visibleAttachments = @$el.find(".attachments-section").find(".sc-attachment").not(".d-none").length
    return (visibleAttachments * singleAttachmentWidth) > attachmentSectionWidth

  attachmentSectionVisibleWidth: =>
    return @$el.find(".tweet-content-text").width() - 140

  displayAttachmentScroll: =>
    @$el.find(".attachment-scroll-backwards")
      .addClass("ticket-attachment-scroll-backwards")
      .removeClass("attachment-scroll-backwards")
    @$el.find(".attachment-scroll-forwards")
      .addClass("ticket-attachment-scroll-forwards")
      .removeClass("attachment-scroll-forwards")
    unless @canScrollAttachmentsForwards()
      @$el.find(".ticket-attachment-scroll-backwards").addClass("d-none")
      @$el.find(".ticket-attachment-scroll-forwards").addClass("d-none")

  isMention: ->
    interaction = @model.summaryInteraction()
    if interaction.type() in ["instagramComment", "instagramMedia", "instagram"]
      interaction.isMention()
    else
      false
